<ng-multiselect-dropdown [placeholder]="'Productos'" [settings]="dropdownSettings" [data]="dropdownList" [disabled]="isDropdownDisabled"
    appendTo="body" [(ngModel)]="selectedItems" (onSelect)="changeItems()" (onDeSelect)="changeItems()"
    (onSelectAll)="allItems($event)" (onDeSelectAll)="anyItems()">
</ng-multiselect-dropdown>